<div class="download-dialog">
  <div class="download-header">
    <h2 *ngIf="data.isDownloading && data.operationType === 'upload'">Uploading 1 item</h2>
    <h2 *ngIf="data.isDownloading && data.operationType !== 'upload'">Downloading 1 item</h2>
    <h2 *ngIf="data.isComplete && data.operationType === 'upload'">Upload Complete</h2>
    <h2 *ngIf="data.isComplete && data.operationType !== 'upload'">Download Complete</h2>
    <h2 *ngIf="data.hasFailed && data.operationType === 'upload'">Upload Failed</h2>
    <h2 *ngIf="data.hasFailed && data.operationType !== 'upload'">Download Failed</h2>
    <div class="actions">
      <button mat-icon-button (click)="toggleExpand()">
        <mat-icon>{{ isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
      <button mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div [ngClass]="{'collapsed': !isExpanded, 'expanded': isExpanded}" class="collapsible-content">
    <div *ngIf="data.isDownloading" class="download-footer">
      <span class="status-text">{{ data.progress ? data.progress + '% Completed' : 'Less than a minute left' }}</span>
      <button mat-button color="primary" (click)="closeDialog()">Cancel</button>
    </div>
    
    <div class="download-content">
      <div class="file-info">
        <mat-icon class="file-icon">description</mat-icon>
        <span class="file-name">{{ data.filename }}</span>
      </div>
      
      <div *ngIf="data.isDownloading" class="progress-container">
        <mat-progress-spinner 
          *ngIf="!data.progress || data.progress === 0" 
          color="primary" 
          mode="indeterminate" 
          diameter="28">
        </mat-progress-spinner>
        <mat-progress-spinner 
          *ngIf="data.progress && data.progress > 0" 
          color="primary" 
          mode="determinate" 
          [value]="data.progress"
          diameter="28">
        </mat-progress-spinner>
      </div>
      
      <div *ngIf="data.isComplete" class="complete-container">
        <div class="success-icon">
          <mat-icon>check_circle</mat-icon>
        </div>
      </div>

      <div *ngIf="data.hasFailed" class="failed-container">
        <div class="error-icon">
          <mat-icon>error</mat-icon>
        </div>
      </div>
    </div>
  </div>
</div> 